// extracted by mini-css-extract-plugin
export default {"wrapper":"KzhZ944FW04wOhFVL54q","button":"cDTiAoa7JXufCS_P3LYS","icon":"YUDO9bOrPDLBH8PiNgG2"};